import React from 'react'
import { Link } from 'react-router-dom'

import { Svg, Icon } from '@components/shared/elements'

import './PageHeader.scss'

import { isEmpty } from 'lodash'

import { HashLink } from 'react-router-hash-link'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import $ from 'jquery'

import * as PRODUCT_ACTION from '@store/products/actions'
import * as SHARED_ACTION from '@store/shared/actions'
import { SearchBar } from '@components/children/SearchBar'

class PageHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showNavigation: false,
      showMenu: false,
      showMenuAbout: false,
      showMenuAboutMobile: false,
    }
    this.el = React.createRef()
  }

  _toggleNavigation(event) {
    event.preventDefault()
    if (document) {
      const { body } = document
      if (!body.classList.contains('overflow-hidden')) {
        body.classList.add('overflow-hidden')
      } else {
        body.classList.remove('overflow-hidden')
      }
    }
    this.setState({
      showNavigation: !this.state.showNavigation,
    })
  }

  _toggleMenu(event) {
    this.setState({ showMenu: !this.state.showMenu })
  }

  _toggleMenuAbout(event) {
    this.setState({ showMenuAbout: !this.state.showMenuAbout })
  }

  _toggleMenuAboutMobile(event) {
    this.setState({ showMenuAboutMobile: !this.state.showMenuAboutMobile })
  }

  _apartmentsGo(event, region) {

    this.props.actions.switchLocation(region)
    this._toggleMenu(event)
  }

  _getRegions() {
    this.props.actions.getRegions().then(() => {
    }).catch((error) => {
      // eslint-disable-next-line
      console.log('states error', error)
    })
  }

  componentDidMount() {
    $(this.el.current).foundation()
    this._getRegions()
  }

  _handlePushDataLayer(event, key) {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'clickEvent',
        'eventCategory': key,
        'eventAction': event.type || 'click',
        'eventLabel': 'instituto-cyrela-header:instituto-cyrela',
        'eventNonInteraction': '0',
      })
    }
  }
  _getApartmentsLink() {
    let currLoc = { Url: '#' }
    if (this.props.regions && this.props.regions.estados && this.props.regions.estados.length > 0) {
      currLoc = this.props.regions.estados.find(e => e.IdEstado === this.props.region)
    }

    if (currLoc) {
      return `/apartamentos/${currLoc.Url}`
    }

    return '#'
  }

  render() {
    // const regions = !isEmpty(this.props.regions) ? this.props.regions.estados : []
    // const hasRegions = !isEmpty(regions)

    let simulatorLink = '/simulador'
    // let contactLink = '/contato'
    const currentPage = window.location.pathname.split('/')[1]
    let hideSimulator = false
    if (currentPage === 'apartamento' && !!this.props.imovel && !isEmpty(this.props.imovel)) {
      hideSimulator = this.props.imovel.RemoverLinkSimulador
      const imovelCode = !!this.props.imovel && !!this.props.imovel.imovelId ?
        this.props.imovel.imovelId : '0'
      const imovelFacilita = !!this.props.imovel && !!this.props.imovel.IdFacilita ?
        this.props.imovel.IdFacilita : '0'
      simulatorLink += `?idimovel=${imovelCode}`
      // contactLink += `?idimovel=${imovelCode}`
      if (imovelFacilita) {
        // contactLink += `&idFacilita=${imovelFacilita}`
        simulatorLink += `&idFacilita=${imovelFacilita}`
      }
    }

    const realtor = currentPage === 'vendedor'

    return (
      <header
        id='header'
        className='page-header'
        ref={this.el}
        data-ga-name='header'
        data-module='header'
      >
        <div className='page-header__fixed'>

          {realtor && (
            <div className='page-header__nav grid-x grid-margin-x align-middle'>
              <div className='cell shrink'>
                <div className='brand'>
                  <span className='show-for-sr'>Vivaz residencial</span>
                </div>
              </div>
            </div>
          )}

          {!realtor && (
            <React.Fragment>
              <div className='page-header__first'>
                <div className='grid-container'>
                  <div className='grid-x align-middle align-justify'>
                    <nav>
                      <ul>

                        <li className='about-sub-menu' open={this.state.pinSubMenu}>
                          <span>
                            <HashLink to='/sobre-nos#sobre'> Sobre nós </HashLink>
                            <Icon icon='chevron-down' size='sm' />
                          </span>
                          <HashLink to='/sobre-nos#vivico' className='menu-vivico'>Conheça o Vivico</HashLink>
                        </li>

                        <li><Link to='/instituto-cyrela' onClick={(event) => this._handlePushDataLayer(event, 'instituto-cyrela')}>Instituto Cyrela</Link></li>
                        <li><Link to='/duvidas-frequentes'>Dúvidas</Link></li>
                        <li><a href={this._getApartmentsLink()} className='highlight'>Empreendimentos</a></li>
                        <li><a href='https://blog.meuvivaz.com.br' className='highlight'>Blog Vivaz</a></li>
                        {(+this.props.region === 1) && (
                          <li>
                            <Link to='/mapa-de-lojas'>
                              <Svg src={'/Files/vivaz.com.br/content/img/icons/pin.svg'} />
                            Lojas Vivaz
                          </Link>
                          </li>
                        )}
                        <li>
                          <a href='#rodape' data-smooth-scroll>
                            <Icon icon='phone' size='sm' className='rotate' />
                          Contato
                        </a>
                        </li>
                        <li>
                          <a href='https://lp.meuvivaz.com.br/empreendimentos-his' data-smooth-scroll>
                          Empreendimentos HIS/HMP
                          </a>
                        </li>
                        <li>
                          <a href='https://relacionamentovivaz.com.br' className='pr0'>
                            <Icon iconType='far' icon='user' size='sm' />
                          Portal do Cliente
                        </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

              <div className='grid-container'>
                <div className='page-header__nav grid-x grid-margin-x align-middle'>
                  <div className='cell shrink'>
                    <div className='brand'>
                      <Link to='/'>
                        {this.props.isHome
                          ? <h1 className='mb0'><span className='show-for-sr'>Vivaz residencial</span></h1>
                          : <span className='show-for-sr'>Vivaz residencial</span>
                        }
                      </Link>
                    </div>
                  </div>
                  <div className='cell auto ml0 mr0 page-header__nav__middle'>

                    <SearchBar location={this.props.location} />

                    <button
                      onClick={(event) => this._toggleNavigation(event)}
                      className='hide-for-large toggle-menu-button'
                      type='button'
                    >
                      <Icon icon='bars' />&nbsp;
                    <span className='block text-small' aria-label='Menu mobile'>
                        Menu
                    </span>
                    </button>
                  </div>
                  <div className='cell shrink show-for-large'>
                    <div>
                      {!hideSimulator && !this.props.location.pathname.includes('simulador-cva-mcmv') && (
                        <Link to={simulatorLink}
                          className='button no-shadow mb0 btn-simulate'
                          data-ga-action='cta-simular-financiamento'
                        >Simular financiamento</Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}

          <div className='grid-container'>
            <div className={`page-header__dropdown hide-for-large scroll-y ${!this.state.showNavigation && 'closed'}`}>
              <div className='grid-x grid-margin-x align-middle align-justify mb4 hide-for-medium'>
                <div className='cell shrink'>
                  <div className='brand' onClick={(event) => this._toggleNavigation(event)}>
                    <Link to='/'>
                      <span className='show-for-sr'>Vivaz residencial</span>
                    </Link>
                  </div>
                </div>
                <div className='cell shrink'>
                  <button onClick={(event) => this._toggleNavigation(event)} className='close-menu-button' type='button'><Icon icon='times' /></button>
                </div>
              </div>

              <h2 className='h3 menu__mobile-title'>Menu acessos</h2>
              <ul className='menu vertical'>

                {(+this.props.region === 1) && (
                  <li onClick={(event) => this._toggleNavigation(event)}>
                    <Link to='/mapa-de-lojas'>
                      <Svg src={'/Files/vivaz.com.br/content/img/icons/pin.svg'} />
                    Lojas Vivaz
                  </Link>
                  </li>
                )}
                <li onClick={(event) => this._toggleNavigation(event)}>
                  <a href='#rodape' data-smooth-scroll>
                    <Icon icon='phone' size='sm' className='rotate' />
                    Contato
                  </a>
                </li>
                <li>
                  <a href='https://relacionamentovivaz.com.br'>
                    <Icon iconType='far' icon='user' size='sm' />
                    Portal do Cliente
                  </a>
                </li>
                <li>
                  <a href='https://lp.meuvivaz.com.br/empreendimentos-his' target='_blank' rel='noopener noreferrer'>
                   Empreendimentos HIS/HMP
                  </a>
                                      
                </li>
                <li>
                  <a href={this._getApartmentsLink()} className='pr0 highlight'>
                    Empreendimentos
                  </a>
                </li><li>
                  <a href='https://blog.meuvivaz.com.br' className='pr0 highlight'>
                    Blog Vivaz
                  </a>
                </li>
              </ul>

              <hr className='menu__mobile-divider' />

              <ul className='menu vertical'>
                <li onClick={(event) => this._toggleNavigation(event)}><HashLink to='/sobre-nos#sobre' className='pl0'>Sobre nós</HashLink></li>
                <li onClick={(event) => this._toggleNavigation(event)} className='menu-vivico'><HashLink to='/sobre-nos#vivico'>Conheça o Vivico</HashLink></li>
                <li onClick={(event) => {
                  this._toggleNavigation(event)
                  this._handlePushDataLayer(event, 'instituto-cyrela')
                }}>
                  <Link to='/instituto-cyrela'>Instituto Cyrela</Link>
                </li>
                {this.props.region !== 24 && (
                  <li onClick={(event) => this._toggleNavigation(event)}><Link to='/duvidas-frequentes'>Dúvidas</Link></li>
                )}
              </ul>

              {!hideSimulator && !this.props.location.pathname.includes('simulador-cva-mcmv') && (
                <span onClick={(event) => this._toggleNavigation(event)}>
                  <Link to={simulatorLink}
                    className='button no-shadow mb0 ml2 small-12 btn-simulate'
                    data-ga-action='cta-simular-financiamento'
                  >Simular financiamento</Link>
                </span>
              )}
            </div>
          </div>
        </div>
      </header>
    )
  }
}
const mapStateToProps = state => {
  return {
    region: state.shared.region,
    regions: state.shared.regions,
    reduxstate: state,
    imovel: state.products.product.imovel,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...PRODUCT_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader)



// WEBPACK FOOTER //
// ./src/components/shared/PageHeader/PageHeader.js